import { styled, Theme } from '@mui/material/styles';
import { Box, Collapse, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as BuildWiseLogo } from 'assets/icons/login_logo_large.svg';
import { ReactComponent as BuildWiseTitle } from 'assets/icons/logo_title.svg';

function SmallBrandBanner() {
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <Collapse in={isSm}>
      <BuildWiseBrandContainer>
        <BuildWiseLogo style={{ maxHeight: 80 }} />
        <BuildWiseTitle style={{ height: 30, marginTop: 24 }} />
        <BuildWiseCaption sx={{ marginTop: 1, marginBottom: 0, fontSize: 18 }}>
          Build with Collective Wisdom.
        </BuildWiseCaption>
      </BuildWiseBrandContainer>
    </Collapse>
  );
}

const BuildWiseBrandContainer = styled(Box, { label: 'BuildWiseBrandContainer' })(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 16,
    marginBottom: 16,
  },
}));

const BuildWiseCaption = styled(Typography, { label: 'BuildWiseCaption' })(({ theme }) => ({
  fontSize: 24,
  fontWeight: 500,
  lineHeight: '38px',
  color: theme.palette.secondary.main,
  marginTop: 16,
  marginBottom: 80,
}));

export default SmallBrandBanner;
